import { DEFAULT_PHONE_NUMBER_VALUE } from '../constants';
import { normalizePhoneNumber } from './normalize-phone-number.function';

export function isPhoneNumberValid(phoneNumber: string): boolean {
  phoneNumber = normalizePhoneNumber(phoneNumber);

  if (!phoneNumber) {
    return false;
  }

  if (phoneNumber.length < 7) {
    return false;
  }

  if (phoneNumber.startsWith(DEFAULT_PHONE_NUMBER_VALUE.slice(1)) && phoneNumber.length !== 12) {
    return false;
  }

  return true;
}
